
/**
 * Fonction globale pour remplacer la fonction jQuery
 *
 *  $(function() {
 *      // ...
 *  });
 *
 *  Elle est utilisée en particulier pour la stack Blade "onload".
 *  Mais peut évidement être utilisée dans d'autres contextes.
 */
window.documentReady = function (fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}


/**
 * Bootstrap 5
 *
 * Ici nous choisissons les composants Bootstrap que nous souhaitons
 * importer et utiliser.
 *
 * Après avoir été importés, les composants sont mis dans le contexte global via un "objet" bootstrap.
 */

import {
    Alert
 //   , Button
 //   , Carousel
 //   , Collapse
 //   , Dropdown
 //   , Modal
 //   , Offcanvas
    , Popover
 //   , ScrollSpy
 //   , Tab
 //   , Toast
    , Tooltip
} from 'bootstrap';

window.bootstrap = {};
window.bootstrap.Alert = Alert;
// window.bootstrap.Button = Button;
// window.bootstrap.Carousel = Carousel;
// window.bootstrap.Collapse = Collapse;
// window.bootstrap.Dropdown = Dropdown;
// window.bootstrap.Modal = Modal;
// window.bootstrap.Offcanvas = Offcanvas;
window.bootstrap.Popover = Popover;
// window.bootstrap.ScrollSpy = ScrollSpy;
// window.bootstrap.Tab = Tab;
// window.bootstrap.Toast = Toast;
window.bootstrap.Tooltip = Tooltip;


/**
 * Axios
 *
 * Nous chargeons la bibliothèque HTTP axios qui permet de lancer facilement des requêtes
 * vers notre back-end Laravel. Cette bibliothèque gère automatiquement l'envoi du jeton CSRF
 * en tant qu'en-tête en fonction de la valeur du cookie de jeton "XSRF".
 */

// import axios from 'axios';
// window.axios = axios;

// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * SweetAlert2
 *
 * Utilisé pour les notifications avec la configuration de base de notre notifier.
 */

import Swal from 'sweetalert2'
window.Swal = Swal;


/**
 * Fontawesome
 *
 * Êtes-vous sur de vouloir utiliser cela sur le front ? C'est beaucoup de Mo à charger...
 * Pourquoi ne pas utiliser plutôt de simples images svg ?
 */
// require('@fortawesome/fontawesome-pro/js/brands.js');
// require('@fortawesome/fontawesome-pro/js/duotone.js');
// require('@fortawesome/fontawesome-pro/js/light.js');
// require('@fortawesome/fontawesome-pro/js/regular.js');
// require('@fortawesome/fontawesome-pro/js/solid.js');
// require('@fortawesome/fontawesome-pro/js/thin.js');
// require('@fortawesome/fontawesome-pro/js/fontawesome.js'); // requis mais en dernier
